import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
              Mentions <strong className="text-teal-600">Légales</strong>
            </h1>
            
            <div className="bg-gray-50 rounded-lg p-8 space-y-8">
              <div className="bg-white border-l-4 border-teal-600 p-6">
                <p className="text-gray-700 leading-relaxed font-semibold">
                  Site Loué par AccesLeads UAB à DFPRO SAS
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Dernière mise à jour : 20/11/2025
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Propriétaire du site</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>AccesLeads UAB</strong></p>
                  <p>Forme juridique : UAB</p>
                  <p>Adresse : Vilnius, Architektų g. 56-101, LT-04111, Lituanie</p>
                  <p>Code d'identification de l'entreprise : 307353988</p>
                  <p>TVA intracommunautaire : 307353988</p>
                  <p>Email : info@accesleads.lt</p>
                  <p>Responsable de la publication : AccesLeads UAB</p>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Exploitant du site</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>DFPRO</strong></p>
                  <p>Forme juridique : SAS</p>
                  <p>Adresse : 100 Route de Nîmes – 30132 Caissargues</p>
                  <p>Numéro Siret : 98477526200020</p>
                  <p>TVA intracommunautaire : FR96984775262</p>
                  <p>Email : info@dfpro.fr</p>
                  <p>Téléphone : 04.65.84.88.50</p>
                  <p>Responsable éditorial : AccesLeads UAB</p>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Hébergeur du site</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>OVH</strong></p>
                  <p>Adresse : 2, rue Kellermann, 59100 Roubaix</p>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">4. Propriété intellectuelle</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  AccesLeads UAB reste propriétaire du site, de sa structure, du code et de sa conception (textes, images, offres commerciales) qu'il publie. DFPRO SAS est l'utilisateur des contenus.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Toute reproduction totale ou partielle est interdite sans autorisation.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Le site est mis en location avec option d'achat après la période de contrat à savoir 36 mois.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">5. Responsabilités</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>AccesLeads UAB :</strong> met à disposition l'infrastructure technique et est responsable des contenus publiés à la demande de la société DFPRO SAS.</li>
                  <li><strong>DFPRO SAS :</strong> responsable des contenus, de la légalité, du respect du RGPD et des relations avec les utilisateurs.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">6. Données personnelles (RGPD)</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>Responsable du traitement : DFPRO SAS</strong></p>
                  <p>Adresse : 100 Route de Nîmes – 30132 Caissargues</p>
                  <p>Email RGPD : info@dfpro.fr</p>
                  <p className="mt-4">
                    Les utilisateurs disposent des droits d'accès, de rectification, d'opposition, de suppression et de portabilité.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">7. Cookies</h3>
                <p className="text-gray-700 leading-relaxed">
                  Le site peut utiliser différents types de cookies. L'utilisateur peut gérer son consentement via le module prévu à cet effet.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">8. Conditions d'utilisation</h3>
                <p className="text-gray-700 leading-relaxed">
                  L'utilisation du site implique l'acceptation totale des présentes mentions légales.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">9. Droit applicable et juridiction compétente</h3>
                <p className="text-gray-700 leading-relaxed">
                  Pour l'infrastructure technique et l'exploitation : loi lituanienne (tribunaux lituaniens compétents).
                </p>
              </div>

              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 mt-8">
                <h4 className="text-xl font-bold text-gray-900 mb-3">Contact</h4>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Pour toute question :
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>DFPRO SAS</strong><br />
                  Email : info@dfpro.fr<br />
                  Téléphone : 04.65.84.88.50
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;
